import { render, staticRenderFns } from "./FooterLinksUseful.vue?vue&type=template&id=7822b22c"
import script from "./FooterLinksUseful.vue?vue&type=script&lang=js"
export * from "./FooterLinksUseful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports